export const itCoreMessages = {
  'common.home': 'Home',
  'common.admin': 'Admin',
  'common.cart': 'Carrello',
  'common.close': 'Chiudi',
  'common.retry': 'Riprova',
  'common.logout': 'Esci',
  'common.loading': 'Caricamento...',
  'common.never': 'Mai',
  'common.customerArea': 'Area cliente',
  'common.accountDashboard': 'Dashboard account',
  'common.accountOrders': 'I miei ordini',
  'common.accountSupport': 'Assistenza',
  'common.goToLogin': 'Vai al login',
  'common.goBack': 'Torna indietro',
  'common.reload': 'Ricarica',
  'common.goCatalog': 'Torna al catalogo',
  'common.goHome': 'Torna alla home',
  'common.contactSupport': 'Contatta assistenza',
  'common.language.switcherLabel': 'Lingua',
  'common.language.it': 'Italiano',
  'common.language.en': 'Inglese',

  'cart.preCheckout': 'Checkout preliminare',
  'cart.title': 'Carrello',
  'cart.continueShopping': 'Continua acquisti',
  'cart.clear': 'Svuota carrello',
  'cart.loading': 'Caricamento carrello...',
  'cart.emptyTitle': 'Il carrello e vuoto',
  'cart.emptyDescription': 'Aggiungi prodotti dal catalogo per iniziare il checkout.',
  'cart.unitPrice': 'Prezzo unitario: {price}',
  'cart.remove': 'Rimuovi',
  'cart.totalQuantity': 'Quantita totale',
  'cart.subtotal': 'Subtotale',
  'cart.sidebarTitle': 'Riepilogo ordine',
  'cart.sidebarItems': '{count} articoli nel carrello',
  'cart.checkout': 'Procedi al pagamento',
  'cart.checkoutBusy': 'Reindirizzamento a Stripe...',
  'cart.checkoutLoginRequired': 'Effettua login cliente per procedere al checkout.',
  'cart.checkoutMissingCart': 'Carrello non disponibile. Ricarica la pagina.',
  'cart.checkoutGenericError': 'Impossibile avviare il checkout Stripe.',
  'cart.checkoutServiceUnavailable': 'Servizio pagamenti temporaneamente non disponibile. Riprova tra poco.',
  'cart.checkoutTimeout': 'Il checkout sta impiegando troppo tempo. Verifica i tuoi ordini tra qualche istante.',
  'cart.checkoutViewOrdersCta': 'Vai ai tuoi ordini',

  'cms.page.preview': 'Anteprima bozza',
  'cms.page.page': 'Pagina CMS',
  'cms.page.loading': 'Caricamento pagina...',
  'cms.page.unavailable': 'Pagina non disponibile.',
  'cms.page.badge.published': 'Pubblicata',
  'cms.page.badge.draft': 'Bozza',
  'cms.page.badge.preview': 'Anteprima',

  'home.fallback.shopFrontend': 'Shop frontend',
  'home.fallback.cart': 'Carrello',
  'home.fallback.adminArea': 'Area riservata',

  'error.unknownEyebrow': '{code} · Errore',
  'error.unknownTitle': 'Scenario imprevisto',
  'error.unknownDescription': 'Si e verificato un errore non classificato.',

  'error.401.eyebrow': '401 · Non autorizzato',
  'error.401.title': 'Porta chiusa a doppia mandata',
  'error.401.description': 'Questa area richiede autenticazione. Verifica login o token e riprova.',
  'error.403.eyebrow': '403 · Accesso negato',
  'error.403.title': 'Permesso non sufficiente',
  'error.403.description': 'Hai raggiunto la pagina, ma non hai i privilegi per proseguire.',
  'error.404.eyebrow': '404 · Risorsa non trovata',
  'error.404.title': 'Ops, la risorsa richiesta non è stata trovata',
  'error.404.description': 'Controlla l\'indirizzo oppure torna alla home per continuare la navigazione.',
  'error.418.eyebrow': '418 · Teapot mode',
  'error.418.title': 'La teiera si rifiuta di servire caffe',
  'error.418.description': 'Errore di test ironico, perfetto per verifiche UI e route custom.',
  'error.500.eyebrow': 'Errore temporaneo',
  'error.500.title': 'Qualcosa non ha risposto come previsto',
  'error.500.description':
    'Stiamo avendo un problema temporaneo nel caricare questa pagina. Riprova tra qualche secondo oppure torna alla home.',
  'error.500.referenceLabel': 'Riferimento',
  'error.503.eyebrow': '503 · Servizio non disponibile',
  'error.503.title': 'Officina momentaneamente occupata',
  'error.503.description': 'Il servizio e temporaneamente fuori uso o in manutenzione.',
} as const
